(function() {
  'use strict';

  angular
    .module('account.resolveAccount')
    .factory('ResolveAccount', ResolveAccount);

  ResolveAccount.$inject = ['$q', 'Auth', '$route', '$injector', '$rootScope'];

  function ResolveAccount($q, Auth, $route, $injector, $rootScope) {
    return function() {
      var deferred = $q.defer();
      var service = $route.current.contentType ? $injector.get($route.current.contentType) : null;

      if (!Auth.getHeaderSessionId() || !Auth.userIsLoggedIn() || !$rootScope.accountInfo) {
        Auth.setHeaderSessionId(mfConfig.sessionId);
        $rootScope.accountInfo = mfConfig;
        Auth.setSelectedAccount(mfConfig);
      }

      deferred.resolve(service);

      return deferred.promise;
    };
  }
})();
